<script setup lang="ts">
  import { useAppRouting } from '@/composables/useAppRouting'
  import { KsIcon } from '@aschehoug/kloss'

  const props = defineProps<{
    buttonText: string
  }>()

  const { getParentRoute } = useAppRouting()

</script>
<template>
  <nav>
    <router-link :to="getParentRoute()">
      <KsIcon id="chevron-left" />
      <span v-html="props.buttonText" />
    </router-link>
  </nav>
</template>

<style lang="scss" scoped>
  nav {
    padding: 0 24px;
    margin: 0 auto;
  }

  a {
    text-decoration: none;
    display: flex;
    align-items: center;
    justify-content: center;
    color: var(--app-theme-color);
    gap: 4px;
    padding: 16px 16px 16px 0;
    width: fit-content;

    svg {
      width: 1rem !important;
      height: 1rem !important;
    }

    &:focus-visible {
      outline: 3px solid var(--ks-focusring);
    }
  }
</style>
